
export default {
  data() {
    return {
      windowWidth:null,
      windowHeight:null
    };
  },
  mounted() {
    window.addEventListener('resize', this.resize);
    this.resize()
  },

  computed: {
    
    maxDimension(){
      return Math.max(this.windowWidth,this.windowHeight)
    },
    
    windowRatio(){
      return this.windowWidth/this.windowHeight
    },
    
  },
  methods: {
    resize(){
      this.windowWidth= window.innerWidth
      this.windowHeight= window.innerHeight
    },
    coverLeft(width,height){
      return Math.floor((this.windowWidth-this.coverScale(width,height)*width)/2/this.coverScale(width,height))
    },
    coverTop(width,height){
      return Math.floor((this.windowHeight-this.coverScale(width,height)*height)/2/this.coverScale(width,height))
    },
    coverScale(width,height){
      let ws=this.windowWidth/width
      let hs=this.windowHeight/height
      return Math.max(ws,hs)
    },
    containScale(width,height){
      let ws=this.windowWidth/width
      let hs=this.windowHeight/height
      return Math.min(ws,hs)
    },
    containLeft(width,height){
      return Math.floor((this.windowWidth-this.containScale(width,height)*width)/2/this.containScale(width,height))
    },
    containTop(width,height){
      return Math.floor((this.windowHeight-this.containScale(width,height)*height)/2/this.containScale(width,height))
    },
      ratio(width,height){
        return width/height
      }
  }
  
}